'use strict'

import React from 'react'

import './RadioButton.less'

import classNames from 'classnames'
import PropTypes from 'prop-types'

export default class RadioButton extends React.Component {

  static propTypes = {
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    horizontal: PropTypes.bool,
    selectedValue: PropTypes.any,
    value: PropTypes.any
  }

  static defaultProps = {
    disabled: false,
    horizontal: false
  }

  handleClick = () => {
    if (!this.props.disabled && this.props.onChange) {
      this.props.onChange(this.props.value)
    }
  }

  render () {
    let radioClasses = classNames({
      'nmc-radio-button': true,
      'nmc-radio-button-horizontal': this.props.horizontal,
      'disabled': this.props.disabled,
      'selected': this.props.selectedValue === this.props.value
    })

    return (
      <span className={radioClasses} data-id={this.props.value} key={this.props.value} onClick={this.handleClick} >
        <input className='nmc-radio-button-button' type='radio' value={this.props.value} checked={this.props.selectedValue === this.props.value}
          onChange={this.handleClick} />
        <span className='nmc-radio-button-button-styled' />
        <span className='nmc-radio-button-label'>
          {this.props.children}
        </span>
      </span>
    )
  }
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/RadioButton/RadioButton.js